import { ENTITY_LABELS } from "../../../utils/labelMapping";
import { useEffect, useContext, useState, useRef } from "react";
import {
  Skeleton,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";

import Table, {
  StyledTableCell,
  StyledTableRow,
} from "../../../Component/UI/Table/Table";
import MUICard from "../../../Component/UI/MUICard/MUICard";
import classes from "./CoreAttributes.module.css";
import { DiscoveryContext } from "../discovery-context";
import { extractDomain } from "../../../utils/helpers";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import DetailedTableModal from "../../BrandAudit/BrandAuditMetricDetails";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { InfoOutlined } from "@mui/icons-material";
import { metricExplainations } from "../../../utils/constant";
import MUIToolTip from "../../../Component/UI/ActionTooltip/MUIToolTip";
import {
  createActionMetric,
  fetchActionMetrics,
} from "../../../redux/actions/metricActions";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/auth-context";
import { useDispatch } from "react-redux";
import { formatSourceData,formatOldSourceData } from "../../../utils/metric-sources"
import BrandAvatar from "../../../Component/Avatar/Avatar"

const TABLE_HEADERS = [
  {
    id: "attr",
    name: `${ENTITY_LABELS.Brand} Pillars`,
  },
];

export default function CoreAttributes({ entity }) {
  // const [error, setError] = useState();
  const discoveryCtx = useContext(DiscoveryContext);
  const abortControllerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);

  const [isActionLoading, setIsActionLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const dispatch = useDispatch();
  const customerId = user?.customer_id;
  const category = discoveryCtx.category;
  const llm = discoveryCtx.llm;
  const market = discoveryCtx.market;
  const type = discoveryCtx.type;
  const headers = discoveryCtx.competitors.map((item) => item.name);
  const showOldSourcesRecord = discoveryCtx.state.sourceValidationStatus === "PENDING";
  function formatName(str) {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const saveActions = async (actionStatement, explanation, sources, brand) => {
    setIsActionLoading(true);
    const modifiedObj = {
      title: actionStatement,
      rationale: explanation,
      brand,
      persona: "General Persona",
      geography: market == "General Market" ? "General Location" : market,
      market: "General Market",
      category,
      llm,
      isProduct: type === "product" ? true : false,
      sources,
    };

    const payload = {
      action_json: [modifiedObj],
      is_archived: 0,
      is_active: 1,
    };
    dispatch(createActionMetric(customerId, payload))
      .then(() => {
        dispatch(fetchActionMetrics(customerId));
        setIsActionLoading(false);
        toast.success("Action Added!", {
          autoClose: 700,
        });
      })
      .catch(() => {
        setIsActionLoading(false);
        toast.error("Something went wrong!", {
          autoClose: 700,
        });
      });
  }

  function renderRows(rowItem, index) {
    const attName = formatName(rowItem?.name);
    console.log("rowItem", rowItem)
    return (
      <StyledTableRow key={index}>
        <Tooltip title={metricExplainations?.[attName]}>
          <StyledTableCell className={classes.attribute_headings}>
            {formatName(rowItem?.name)}
          </StyledTableCell>
        </Tooltip>
        {headers?.map((brand, idx) => {
          const attributeScore = rowItem?.scores?.find(
            (item) => item.name?.toLowerCase() === brand?.toLowerCase()
          );


          if (!attributeScore) {
            // no matching score for this brand → show "-"
            return (
              <StyledTableCell
                key={idx}
                style={{ color: "#000" }}
                className={classes.attribute_score}
              >
                -
              </StyledTableCell>
            );
          }

          // we found a matching score → render that cell
          let color = "#dc3545";
          let rating = "low";

          if (!attributeScore.score) {
            color = "#000";
          } else if (attributeScore.score >= 9) {
            rating = "high";
            color = "#198754";
          } else if (attributeScore.score >= 7) {
            rating = "fair";
            color = "#2196F3";
          }
          const attributeSources =Array.isArray(attributeScore?.sources) && attributeScore?.sources?.length > 0 ? attributeScore?.sources : attributeScore?.productSources
          const isCustomTooltip =
            (attributeScore?.name.toLowerCase() === discoveryCtx.entity.toLowerCase()) && llm?.toLowerCase().includes("search") && (showOldSourcesRecord || isValidated);
          const sources = isCustomTooltip
            ? (showOldSourcesRecord
              ? formatOldSourceData(attributeSources, llm)
              : formatSourceData(attributeSources, llm))
            : {};

          const TooltipComponent = isCustomTooltip ? MUIToolTip : Tooltip;

          const tooltipProps = isCustomTooltip
            ? {
              metric: `${ENTITY_LABELS.Brand} Pillars`,
              attribute: attName,
              metricScore: Number(attributeScore.score).toFixed(0),
              selectedInput: {
                llm,
                market,
                category,
                brand: attributeScore.name,
                product: attributeScore.name,
              },
              addToActionHandler: saveActions,
              actionText: "Add To Action",
              isActionLoading: isActionLoading,
              title: attributeScore.explanation,
              arrow: true,
              isDiscovery: true,
              isBrandAudit: true,
              sources,
              slotProps: {
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -18],
                      },
                    },
                  ],
                },
              }
            }
            : {
              title: attributeScore.explanation,
              arrow: true,
              slotProps: {
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -18],
                      },
                    },
                  ],
                },
              },
            };

          return attributeScore.score ? (
            <TooltipComponent {...tooltipProps}>
              <StyledTableCell
                style={{ color }}
                className={classes.attribute_score}
              >
                {Number(attributeScore.score).toFixed(0)}
              </StyledTableCell>
            </TooltipComponent>
          ) : (
            <StyledTableCell
              key={idx}
              style={{ color }}
              className={classes.attribute_score}
            >
              -
            </StyledTableCell>
          );
        })}

      </StyledTableRow>
    );
  }

  function LoadingSkeletion() {
    return (
      <div className="p-3">
        <Skeleton variant="rectangular" height={30} />
        {Array(8)
          .fill(0)
          .map((_, index) => (
            <Skeleton
              variant="rectangular"
              width={index % 2 === 0 ? "80%" : "97%"}
              key={index}
              className="my-3"
              height={20}
            />
          ))}
      </div>
    );
  }

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);

  useEffect(() => {
    if (
      discoveryCtx?.core_attributes &&
      Object.keys(discoveryCtx?.core_attributes).length > 0
    )
      return;
    // getCoreAttributes();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  function renderHeaders(coreAttributesData) {
    const headers = [
      ...TABLE_HEADERS,
      ...discoveryCtx.competitors.map((item) => ({
        id: item.name,
        name: item.name,
      })),
    ];

    return (
      <TableHead className={classes.table_head}>
        <TableRow>
          {headers.map((header, index) => {
            let ctxCompetitor = null;
            if (index !== 0) {
              ctxCompetitor = discoveryCtx.competitors[index - 1];
            }

            let domain = "";
            if (ctxCompetitor && ctxCompetitor?.domain) {
              domain = extractDomain(ctxCompetitor?.domain);
            }

            return (
              <TableCell key={index} className={classes.table_head_cell}>
                <Tooltip title={header.name} placement="top">
                  <div className={classes.table_head_content}>
                    {index != 0 && (
                      // <img
                      //   data-html2canvas-ignore
                      //   className={classes.table_head_logo}
                      //   src={`https://img.logo.dev/${domain}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
                      // />
                      <BrandAvatar
                       domainName={domain}
                       brandName={header.name}
                     />
                    )}
                    <div
                      className={
                        index === 0
                          ? classes.table_head_text_comp
                          : classes.table_head_text
                      }
                    >
                      {/* {header.name} */}
                      <div className={classes.table_head_title}>
                        <span>
                          {header.name}
                        </span>
                        {index === 0 && !showModal && (
                          <MUIIconButton onClick={() => setShowModal(true)} data-testid="brand-pillars-info-btn">
                            <InfoOutlined />
                          </MUIIconButton>
                        )}
                      </div>
                    </div>
                  </div>
                </Tooltip>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }

  let coreAttributesData = [];
  let loading = true;
  let hasError = false;
  let isValidated = discoveryCtx?.core_attributes?.isValidated || false;
  const transactionStatus = discoveryCtx.state.transactionStatus

  if (
    discoveryCtx?.core_attributes &&
    Object.keys(discoveryCtx?.core_attributes).length > 0 &&
    discoveryCtx?.core_attributes?.summary
  ) {
    coreAttributesData = Object.keys(
      discoveryCtx.core_attributes.category_averages
    ).map((item) => {
      const scores = discoveryCtx.core_attributes.products.map((p) => ({
        name: p.brandName || p.name,
        score: p.attributes[item]?.score,
        explanation: p.attributes[item]?.explanation,
        sources: p.attributes[item]?.sources,
        productSources: p.sources
      }));
      return {
        name: item,
        scores,
      };
    });
    loading = false;
  } else if (transactionStatus === "RETRY") {
    hasError = true;
    loading = false;
  } else if (transactionStatus === "RUNNING") {
    hasError = false;
    loading = true;
  }


  return (
    <MUICard variant="elevated" elevation={0} className={classes.card}>
      {coreAttributesData &&
        coreAttributesData.length > 0 &&
        !loading &&
        !hasError && (
          <>
            <Table
              elevation={0}
              data={coreAttributesData}
              renderHeaders={() => renderHeaders(coreAttributesData)}
              render={renderRows}
            />
            <DetailedTableModal
              show={showModal}
              onClose={() => setShowModal(false)}
              data={coreAttributesData}
              headers={headers}
              renderHeaders={renderHeaders}
              formatName={formatName}
              classes={classes}
              pdfHeight={400}
              pdfTitle={`${entity}-Brand Pillars`}
            />
          </>
        )}
      {loading && !hasError && <LoadingSkeletion />}
      {hasError && (
        <div className={classes.error}>
          <ErrorView
            title={"Error Fetching Brand Pillars"}
            message={"Request Failed"}
          />
        </div>
      )}
    </MUICard>
  );
}
